export default "__VITE_ASSET__e7238dc2__"